var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createDecorator } from "vue-class-component";
import { validationMixin } from "vuelidate";
import regex from "../Validators/regex.ts";
import regexSet from "../Validators/regexSet.ts";
import betweenIf from "../Validators/betweenIf.ts";
export * from "vuelidate/lib/validators";
export { regex, regexSet, betweenIf };
export function Validation(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        return createDecorator(function (componentOptions, k) {
            var mixins = componentOptions.mixins || (componentOptions.mixins = []);
            if (mixins.indexOf(validationMixin) === -1) {
                mixins.push(validationMixin);
            }
            var validations = componentOptions.validations || (componentOptions.validations = {});
            validations[k] = validations[k] || {};
            if (options && options.group) {
                validations[options.group] = validations[options.group] || [];
                validations[options.group].push(k);
            }
            else if (options) {
                validations[k] = __assign({}, validations[k], options);
            }
        })(target, key);
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/Decorators/validation.ts
// module id = 177
// module chunks = 24